import { IntegrationType } from '../lib/integration';
import type {
  StorageProviderListEntry,
  StorageProviderListItem,
} from '../types';

/** Tactical warehouses lead the list as one group; the rest keep their order. */
export function toListEntries(
  providers: StorageProviderListItem[],
): StorageProviderListEntry[] {
  const tactical = providers.filter(
    provider => provider.integration_type === IntegrationType.tactical3pl,
  );
  const others = providers.filter(
    provider => provider.integration_type !== IntegrationType.tactical3pl,
  );

  return [
    ...(tactical.length
      ? [
          {
            kind: 'tactical' as const,
            id: `tactical-${tactical[0]._id}`,
            providers: tactical,
          },
        ]
      : []),
    ...others.map(provider => ({ kind: 'provider' as const, provider })),
  ];
}
